import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/media";
import { formatNewsDate } from "@/utils/news";

interface NewsCardProps {
  item: NewsItem;
  index?: number;
  compact?: boolean;
}

export default function NewsCard({ item, index = 0, compact = false }: NewsCardProps) {
  if (compact) {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex cursor-pointer items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200 hover:bg-background-100"
      >
        <div className="h-16 w-24 shrink-0 overflow-hidden rounded-md bg-background-200">
          <img
            src={item.cover}
            alt={`${item.title}配图`}
            title={`${item.title} - 蘑菇MOGU2影视资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="line-clamp-2 text-sm font-medium text-foreground-900 group-hover:text-primary-700">
            {item.title}
          </h3>
          <p className="mt-1.5 text-xs text-foreground-500">{formatNewsDate(item.date)}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200 animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="h-44 w-full overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title}配图`}
          title={`${item.title} - 蘑菇MOGU2影视资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="flex flex-wrap gap-1.5">
          {item.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-800">
              {tag}
            </span>
          ))}
        </div>
        <h3 className="mt-3 line-clamp-2 text-base font-semibold text-foreground-900 group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm text-foreground-600">{item.summary}</p>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
          <span>{formatNewsDate(item.date)}</span>
          <span className="flex items-center gap-1 text-primary-600">
            阅读全文
            <i className="ri-arrow-right-line"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}